export enum LinkChannel {
    android = 'android',
    ios = 'ios',
    web = 'web',
    webapp = 'webapp',
    webview = 'webview',
    default = 'default',
}
